import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/agents/agent-list.jsx");
